import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PieChartIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        style: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 2l.117.007a1 1 0 01.876.876L13 3v8h8a1 1 0 011 1c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-1 2.062A8.001 8.001 0 0012 20a8.001 8.001 0 007.938-7H12a1 1 0 01-.993-.883L11 12V4.062zm4.056-3.06h.013c.119.007.236.034.346.079 3.579 1.1 6.403 3.774 7.534 7.162.06.18.066.364.027.536.007.034.013.069.017.104L23 9a1 1 0 01-.883.993L22 10h-7.017c-.03 0-.061-.002-.092-.005l-.012-.002C14.423 9.944 14 9.613 14 9V1.978l.003-.056L14 2c0-.635.453-.967.928-.998a.994.994 0 01.128 0zM20.704 8C19.783 6.008 18.105 4.38 16 3.435L16 5.5V8zM14 5.5c0 1.287 1.864 1.332 1.993.133L16 5.5l-.007-.133C15.864 4.168 14 4.213 14 5.5z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
PieChartIcon.isCarinaIcon = true;
export default PieChartIcon;
